import React, { useState } from 'react'
import { ImCopy } from 'react-icons/im';
import { GiCheckMark } from 'react-icons/gi';
import './CopyToClip.css';

export default function CopyToClip({text}) {
  const [isCopied, setCopied] = useState(false);
  const [fallback, setFallback] = useState(false);
  
  const copyToClip = async () => {    
    if ('clipboard' in navigator && window.isSecureContext) {
      // Clipboard API is available
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(()=> setCopied(false), 2000);
    } 
    else {
      // Fallback: display manual copy instructions
      setFallback(true);
    }
  }

  return (
      <div className='copyToClipButton' onClick={copyToClip}>
        {isCopied ? <GiCheckMark/> : <ImCopy/>} {fallback && <div> Direct copy is not supported in this environment or browser. Please copy manually.</div>}
      </div>
  )
}
